import OrderDetails from "../symbols/orderDetails";
import { HttpRequestGet, HttpRequestPost } from "../../service";
import { roleName } from "../../utils/roles";
const orderDetailsAction = () => ({
  type: OrderDetails.ORDER_DETAILS,
});
const orderDetailsSuccessAction = (data: any) => ({
  type: OrderDetails.ORDER_DETAILS_SUCCESS,
  payload: data,
});
const orderDetailsFailureAction = (data: any) => ({
  type: OrderDetails.ORDER_DETAILS_FAILURE,
  payload: data,
});
const clearOrderDetailsAction = () => ({
  type: OrderDetails.CLEAR_ORDER_DETAILS,
});
const orderDetailsGoBackAction = () => ({
  type: OrderDetails.GO_BACK,
});
export function getOrderDetails(
  orderId: string,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    dispatch(orderDetailsAction());
    HttpRequestGet(
      `/${roleName().toLowerCase()}/delivery/${orderId}`,
      dispatch,
      orderDetailsSuccessAction,
      orderDetailsFailureAction,
      true,
      callback
    );
  };
}

export function clearOrderDetails() {
  return (dispatch: any) => {
    dispatch(clearOrderDetailsAction());
  };
}

export function goBackToOrdersList(deliveryId: string, callback?: any) {
  return (dispatch: any) => {
    dispatch(orderDetailsGoBackAction());
    HttpRequestPost(
      `/portal/delivery/${deliveryId}/is-no-deliverable`,
      dispatch,
      orderDetailsGoBackAction,
      orderDetailsGoBackAction,
      true,
      {},
      callback
    );
  };
}
